import { Injectable } from "@nestjs/common"
import { InjectRepository } from "@nestjs/typeorm"
import { DataSource, Repository } from "typeorm"
import { CommonResponseModel, VehcileCategoryDto, VehicleModelDto } from "@project-management-system/shared-models"
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object"
import { VehicleModelEntity } from "./vehicle-model-entity"
import { VehicleCategoryEntity } from "../vehicle-category/vehicle-category.entity"


@Injectable()
export class VehicleModelService {
    constructor(
        @InjectRepository(VehicleModelEntity)
        private repo: Repository<VehicleModelEntity>,
        @InjectRepository(VehicleCategoryEntity)
        private categoryRepo: Repository<VehicleCategoryEntity>,
        private readonly dataSource: DataSource,

    ) { }


    async createVehicleModel(req: VehicleModelDto): Promise<CommonResponseModel> {
        try {
            const check = await this.repo.find({ where: { vehicleModel: req.vehicleModel } });
            if (check.length > 0) {
                return new CommonResponseModel(false, 0, 'Vehicle Model already exists');
            }

            const entity = new VehicleModelEntity();
            entity.vehicleModel = req.vehicleModel;
            entity.vehicleCategory = await this.categoryRepo.findOne({ where: { id: req.vehicleCategory } });
            entity.createdUser = req.createdUser;
            entity.isActive = req.isActive;
            entity.versionFlag = req.versionFlag;
            entity.updatedUser = req.updatedUser;

            if (req.id) {
                entity.updatedUser = req.createdUser;
            } else {
                entity.createdUser = req.createdUser;
            }

            const save = await this.repo.save(entity);

            if (!save) {
                return new CommonResponseModel(false, 0, 'Something went wrong in Vehicle Model creation', []);
            } else {
                return new CommonResponseModel(true, 1, 'Created successfully', save);
            }

        } catch (err) {
            throw err;
        }
    }


    async getAllVehicleModel(): Promise<CommonResponseModel> {
        try {
            const data = await this.repo.find({
                relations: ['vehicleCategory'],
                order: { vehicleModel: 'ASC' },
            });
            if (data.length > 0) {
                return new CommonResponseModel(true, 1, 'Data retrieved', data);
            } else {
                return new CommonResponseModel(false, 0, 'No data found', data);
            }
        } catch (err) {
            throw err;
        }
    }

    async getAllVehicleModelByCategory(req: any): Promise<CommonResponseModel> {
        try {
            console.log(req);
            console.log(req.val);

            const data = await this.repo.find({ relations: ["vehicleCategory"], where: { vehicleCategory: { id: req.val } } });
            if (data.length > 0) {
                return new CommonResponseModel(true, 1, 'Data retrieved', data)
            } else {
                return new CommonResponseModel(false, 0, 'No data found', data)
            }

        } catch (err) {
            throw err
        }
    }

    async updateVehiclemodel(req: VehicleModelDto): Promise<CommonResponseModel> {
        try {
            let updateResult;
            updateResult = await this.repo.update(
                { id: req.id },
                {
                    vehicleModel: req.vehicleModel,
                    vehicleCategory: req.vehicleCategory ? { id: req.vehicleCategory } : null,
                }
            );

            if (updateResult.affected > 0) {
                return new CommonResponseModel(true, 11, 'Updated successfully', updateResult);
            } else {
                return new CommonResponseModel(false, 11, 'Update failed', []);
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }


    async activateOrDeactivateVehicleModel(req: VehicleModelDto): Promise<CommonResponseModel> {
        try {
            console.log(req.isActive, 'service-----------')
            const Exists = await this.repo.findOne({ where: { id: req.id } });
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current VehicleModel information.Refresh and try again');
                } else {

                    const update = await this.repo.update(
                        { id: req.id },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10115, 'VehicleModel is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10111, 'VehicleModel is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10114, 'VehicleModel is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10112, 'VehicleModel is already  activated');
                        }
                    }

                }
            } else {
                throw new CommonResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }



}